import { useTranslation } from "react-i18next";

export default function SplitCTA() {
  const { t } = useTranslation();

  return (
    <section className="w-full flex flex-col md:flex-row min-h-[500px] md:h-[600px]">
      <div className="w-full md:w-1/2 relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20flat%20lay%20with%20cream%20knitted%20sweater%20draped%20over%20warm%20beige%20linen%20fine%20leather%20accessories%20and%20delicate%20gold%20tone%20jewelry%20scattered%20artistically%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20editorial%20product%20photography%20warm%20ivory%20and%20sand%20color%20palette%20sophisticated%20Scandinavian%20aesthetic%20generous%20negative%20space%20calm%20serene%20composition%20no%20text&width=1000&height=700&seq=split-cta-hoobuy-v3&orientation=landscape"
          alt="Hoobuy Spreadsheet fashion products collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="inline-block px-3 py-1.5 bg-foreground-950/60 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full">
            {t("cta_split.tag")}
          </span>
        </div>
        <div className="absolute bottom-6 left-6">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-[1.1]">
            {t("cta_split.title_line1")}
            <br />
            {t("cta_split.title_line2")}
            <br />
            <span className="text-primary-300">{t("cta_split.title_line3")}</span>
          </h2>
        </div>
      </div>

      <div className="w-full md:w-1/2 bg-background-50 flex flex-col items-center justify-center px-6 md:px-12 lg:px-16 py-12 md:py-0">
        <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md text-center mb-10 font-light">
          {t("cta_split.desc")}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-10 py-4 text-base font-semibold text-background-50 bg-foreground-950 rounded-full hover:bg-foreground-800 transition-all duration-300 group whitespace-nowrap cursor-pointer"
        >
          {t("cta_split.button")}
          <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}